<script setup lang="ts">
import {decodeJwtPayload} from "~/utils/JwtDecodeUtil";
import {authLogin} from "~/utils/AuthUtil";

const toast = useToast()
const route = useRoute()
const router = useRouter()

const reLoginOpen = ref(false)
const reLoginUsername = ref()

if(process.client) {
  const shareId = useState('shareId')

  if(route.query.shareId) {
    shareId.value = route.query.shareId
  }

  const o3AccessToken = useCookie('o3AccessToken')
  const o3RefreshToken = useCookie('o3RefreshToken')
  const accessToken = useState<string>('accessToken')
  const refreshToken = useState<string>('refreshToken')
  const authUser = useState('authUser')
  if(o3AccessToken.value && o3RefreshToken.value) {
    accessToken.value = o3AccessToken.value
    refreshToken.value = o3RefreshToken.value
    await updateUserInfo()
  }else{

  }

  setInterval(() => {
    if(refreshToken.value) {
      const currentDate = new Date()
      const decodeData = decodeJwtPayload(refreshToken.value)

      if(decodeData) {
        const {id, exp} = decodeData
        if(exp) {
          if(currentDate.getTime() - decodeData.exp.getTime() > -60 * 1000) {
            reLoginOpen.value = true
            reLoginUsername.value = authUser.value?.username
            // console.log('已超时', currentDate.getTime() - decodeData.exp.getTime())
          } else {
            reLoginOpen.value = false
            reLoginUsername.value = null
            // console.log('有效期剩余', currentDate.getTime() - decodeData.exp.getTime())
          }
        }
      }
    }
  }, 5000)
}



useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' }
  ],
  link: [
    { rel: 'icon', href: '/favicon.ico' }
  ],
  htmlAttrs: {
    lang: 'en'
  }
})


useSeoMeta({
  titleTemplate: '%s - Craft'
})

const rePassword = ref()

const submitLoading = ref(false)

function onSubmit () {
  submitLoading.value = true

  authLogin(reLoginUsername.value, rePassword.value).then(() => {
    reLoginOpen.value = false
    rePassword.value = ''
    submitLoading.value = false
    toast.add({
      title: '登录成功，欢迎回来！',
      color: 'green'
    })
  }).catch((e) => {
    submitLoading.value = false

    toast.add({
      title: e.msg || e || '登录失败，请稍后重试',
      color: 'red'
    })
  })
}

const toLogin = () => {
  authLogout()
}
</script>

<template>
  <NuxtLoadingIndicator />
  <nuxt-layout/>
  <UDashboardModal
    v-model="reLoginOpen"
    title="请重新登录"
    prevent-close
  >
    <template #header>
      <div class="w-full flex flex-col gap-2 items-center justify-center">
        <div class="font-bold">
          长时间无操作请验证密码
        </div>
        <div class="text-xs text-gray-500">
          密码验证通过后将保留当前工作区
        </div>
      </div>
    </template>
    <div class="w-full max-w-64 m-auto flex flex-col gap-4 items-center justify-center">
      <UFormGroup class="w-full" label="账号">
        <UInput :model-value="reLoginUsername" disabled />
      </UFormGroup>
      <UFormGroup class="w-full" label="密码">
        <UInput type="password" placeholder="请输入密码" autofocus v-model="rePassword" @keydown.enter="onSubmit" />
      </UFormGroup>
      <UFormGroup class="w-full">
        <UButton block :disabled="submitLoading" @click="onSubmit">确认验证</UButton>
      </UFormGroup>
    </div>

    <UDivider label="OR" />

    <div class="w-full flex items-center justify-center">
      <UButton
          variant="soft"
          @click="toLogin"
      >
        切换其他用户 | 返回登录页面
      </UButton>
    </div>
  </UDashboardModal>
  <UNotifications/>
</template>


<style>
* {
  padding: 0;
  margin: 0;
}

.fade-enter-from,
.fade-leave-to {
  transition: all 0.3s ease;
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  transition: all 0.3s ease;
  opacity: 1;
}

.fade-up-enter-from,
.fade-up-leave-to {
  transition: all 0.3s ease;
  transform: translateY(6px);
  opacity: 0;
}

.fade-up-enter-to,
.fade-up-leave-from {
  transition: all 0.3s ease;
  transform: translateY(0);
  opacity: 1;
}
</style>
